import biLogger from '@wix/web-bi-logger';

export const hfBiConfig = {
  extension: 'hf',
  src: '19',
  init: '500',
  loadComplete: '501',
};

export const mhConfig = {
  extension: 'mhp',
  src: '19',
  signinClick: '200',
  openMenu: '202',
  menuPage: '203',
};

export const legacyhfConfig = {
  extension: 'hp',
  src: '19',
  clickOnHeader: '311',
  clickOnFooter: '312',
  languageChange: '313',
  signinClick: '314'
};

export const headerAndFooterBiLogger = biLogger.factory({endpoint: hfBiConfig.extension}).setDefaults({src: hfBiConfig.src}).logger();
export const mobileHeaderBiLogger = biLogger.factory({endpoint: mhConfig.extension}).setDefaults({src: mhConfig.src}).logger();
export const legacyHeaderAndFooterBiLogger = biLogger.factory({endpoint: legacyhfConfig.extension}).setDefaults({src: legacyhfConfig.src}).logger();

